<template>
  <div>
    <iframe
      :src="blok.formUrl"
      class="size-full min-h-[2000px]"
      frameborder="0"
      marginheight="0"
      marginwidth="0"
    />
  </div>
</template>

<script lang="ts">
export default defineComponent({
  components: {},
  props: {
    blok: {
      type: Object as PropType<{
        formUrl: string
      }>,
      default: () => {},
    },
  },
})
</script>
